export default __webpack_public_path__ + "static/media/tzuyu2.1e336e3f.jpg";